const TypeCustomizer = require('./typeCustomizer');

class AudienceCustomizer extends TypeCustomizer {
	getInitSums({ isAdministrator }) {
		return [isAdministrator ? 'revenue' : 'dataProviderRevenue'];
	}
}

module.exports = AudienceCustomizer;
